import type { FaireBrandEntity } from "../../entity_types/brand";

export const onboarding_onfaire_3: FaireBrandEntity = {
  token: "onboarding_onfaire_3",
  type: "brand",
  name: "Mala the Brand",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/901677914a087daf37d3ba0d2491608f5c577da7df9c429056eae062d6ad59a1.webp",
  minimumOrderDollars: 100,
  rating: 4.8,
  location: "US",
  tags: ["onboarding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
